import { createSlice } from '@reduxjs/toolkit';

const initialValue = {
    isAuth: false
}

const auth = createSlice({
    name: 'auth',
    initialState: initialValue,
    reducers: {
        setAuthAccount: (state, action) => {
            return { ...state, ...{ isAuth: true, ...action.payload } };
        },
        removeAuthAccount: () => initialValue
    }
});

export const { setAuthAccount, removeAuthAccount } = auth.actions;
export default auth.reducer;
